import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@mui/material';
export default () => (_jsx(Typography, { sx: { color: 'text.secondary' }, children: "Course Price Options" }));
//# sourceMappingURL=PriceOptions.js.map